/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CopyIcon20Regular = forwardRef('CopyIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.249 1.001a3.25 3.25 0 0 0-3.25 3.25v9.5a3.25 3.25 0 0 0 3.25 3.25h5.5a3.25 3.25 0 0 0 3.25-3.25v-9.5a3.25 3.25 0 0 0-3.25-3.25h-5.5Zm-1.75 3.25c0-.966.783-1.75 1.75-1.75h5.5c.966 0 1.75.784 1.75 1.75v9.5a1.75 1.75 0 0 1-1.75 1.75h-5.5a1.75 1.75 0 0 1-1.75-1.75v-9.5Z" }),
        React.createElement("path", { d: "M17.563 7.5a.75.75 0 0 0-1.5 0v6.781a3.75 3.75 0 0 1-3.75 3.75H7.5a.75.75 0 0 0 0 1.5h4.813c2.899 0 5.25-2.35 5.25-5.25V7.5Z" })));
});
